// extracted by mini-css-extract-plugin
module.exports = {"card":"FavoritesItems_card__2lkpA","name":"FavoritesItems_name__3SP79","btns":"FavoritesItems_btns__24O7I","price":"FavoritesItems_price__2xeO7"};